import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, useState } from "react";
import { Alert as material_Alert, Collapse, alertClasses } from "@mui/material";
import { CheckCircleOutline, CheckDecagramOutline, Close, MenuDown, MenuUp } from "mdi-material-ui";
import { combineSx } from "../../utils/index.js";
import { IconButton } from "../IconButton/index.js";
import { Stack } from "../Stack/index.js";
import { Button } from "../Button/index.js";
import { Typography } from "../Typography/index.js";
const Alert_alertClasses = {
    message: alertClasses.message,
    action: alertClasses.action
};
const getIcon = (severity)=>{
    if ('success' === severity) return /*#__PURE__*/ jsx(CheckCircleOutline, {});
    if ('new' === severity) return /*#__PURE__*/ jsx(CheckDecagramOutline, {});
};
const getMuiSeverity = (severity)=>{
    if ('new' === severity) return 'info';
    return severity;
};
const Alert_Alert = /*#__PURE__*/ forwardRef(function({ severity = 'success', hideIcon, square, Action, children, onClose, MoreDetails, Header, sx, ...props }, ref) {
    const [detailsVisible, setDetailsVisible] = useState(false);
    const icon = getIcon(severity);
    const ariaLabel = props['aria-label'];
    return /*#__PURE__*/ jsxs(material_Alert, {
        sx: combineSx({
            [`&.${alertClasses.root}`]: {
                alignItems: 'flex-start'
            },
            ...'new' === severity && {
                [`&.${alertClasses.standardInfo}`]: {
                    color: (t)=>t.palette.status.new.highContrast,
                    backgroundColor: (t)=>t.palette.status.new.lowContrast,
                    [`.${alertClasses.icon}`]: {
                        color: (t)=>t.palette.status.new.highContrast
                    }
                }
            }
        }, sx),
        severity: getMuiSeverity(severity),
        square: square,
        ...props,
        ref: ref,
        icon: hideIcon ? false : icon,
        "aria-label": ariaLabel,
        action: Action || onClose ? /*#__PURE__*/ jsxs(Stack, {
            direction: "row",
            gap: 1,
            my: "2px",
            children: [
                Action,
                onClose && /*#__PURE__*/ jsx(IconButton, {
                    "aria-label": ariaLabel ? `close ${ariaLabel}` : "close alert",
                    onClick: onClose,
                    children: /*#__PURE__*/ jsx(Close, {})
                })
            ]
        }) : void 0,
        children: [
            Header && /*#__PURE__*/ jsx(Typography, {
                fontWeight: "bold",
                variant: "h4",
                children: Header
            }),
            children,
            MoreDetails && /*#__PURE__*/ jsxs(Stack, {
                children: [
                    /*#__PURE__*/ jsx(Button, {
                        onClick: ()=>setDetailsVisible(!detailsVisible),
                        StartIcon: detailsVisible ? /*#__PURE__*/ jsx(MenuUp, {}) : /*#__PURE__*/ jsx(MenuDown, {}),
                        variant: "tertiary",
                        size: "small",
                        sx: {
                            width: 'fit-content',
                            padding: 0,
                            fontSize: (theme)=>theme.typography.body2,
                            fontWeight: 'bold'
                        },
                        children: "More details"
                    }),
                    /*#__PURE__*/ jsx(Collapse, {
                        in: detailsVisible,
                        children: /*#__PURE__*/ jsx(Typography, {
                            sx: {
                                marginLeft: '28px'
                            },
                            variant: "body2",
                            children: MoreDetails
                        })
                    })
                ]
            })
        ]
    });
});
export { Alert_Alert as Alert, Alert_alertClasses as alertClasses };

//# sourceMappingURL=Alert.js.map